module.exports = __webpack_public_path__ + "img/9788965962588.a7051444.jpg";